import { OPTION_TYPES } from '../../helpers/ShippingOptionHelper';

class ShippingDataSerializer {
  static deSerializeShippingType(data) {
    if (data.Agencia) {
      return OPTION_TYPES.AGENCY;
    } else if (data.EsEspecial) {
      return OPTION_TYPES.SPECIAL;
    }
    return OPTION_TYPES.SIMPLE;
  }

  static deSerialize(data) {
    const dateData = data.FechaPrometida || {};
    const agency = !data.Agencia ? null : {
      id: data.Agencia,
      name: data.AgenciaNombre,
      extraCost: data.ValorPiso,
    };
    return {
      agency: agency || null,
      date: dateData.Fecha,
      endHour: dateData.HoraFin,
      price: data.ValorFlete,
      shippingType: ShippingDataSerializer.deSerializeShippingType(data),
      startHour: dateData.HoraInicio,
    };
  }
}

export { ShippingDataSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/ShippingDataSerializer.js